export const UserRoles = {
  ADMIN: "Admin",
  OPERATION_MANAGER: "Operations Manager",
  EXECUTIVE_MANAGER: "Executive Manager",
  AGENT: "Agent",
};
